module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav-bar",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('span', [_vm._m(0), _vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "active-class": "active",
      "exact": ""
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/news_list",
      "active-class": "active"
    }
  }, [_vm._v("新闻动态")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/product",
      "active-class": "active"
    }
  }, [_vm._v("产品案例展示")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/about",
      "active-class": "active"
    }
  }, [_vm._v("关于我们")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo-link",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo.png"),
      "alt": "HBHZ"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42dfdc54!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/Navbar.vue
// module id = 174
// module chunks = 1